import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import cn from 'classnames';

import { TInquiryStatus } from '@interfaces/inquiries';
import { inquiryDetailsSelector } from '@store/features/inquiryDraft/inquiryDetails/selectors';

import { ISubmitAnInquiryCTACardProps } from './SubmitAnInquiryCTACard.interface';

import './style.scss';

const SubmitAnInquiryCTACard: FC<ISubmitAnInquiryCTACardProps> = ({ className, onClick }) => {
  const { t } = useTranslation();

  const inquiry = useSelector(inquiryDetailsSelector);
  const disabled = Boolean(inquiry) && inquiry?.inquiryStatusId !== TInquiryStatus.Draft;

  const handleClick = useCallback(() => {
    if (disabled || !onClick) {
      return;
    }
    onClick();
  }, [onClick, disabled]);

  return (
    <Box className={cn('submit-inquiry-cta', className)}>
      <p className="caption">{t('medicationLookup.notSeeingMed')}</p>

      <Button variant="text" onClick={handleClick} disabled={disabled}>
        <span className="submit-inquiry-cta__button-text">
          {t('medicationLookup.submitAnInquiry')}
        </span>
      </Button>
    </Box>
  );
};

export default SubmitAnInquiryCTACard;
